export default __webpack_public_path__ + "static/media/ridevuLogo.994c94d8.svg";